import { useState } from 'react'
import ForgotPasswordOtpInputPage from '../ForgotPasswordOtpInput/ForgotPasswordOtpInputPage';
import ResetPasswordInputPage from '../ResetPasswordInput/ResetPasswordInputPage';
import ChangePasswordPasswordEntryPage from '../ChangePasswordPasswordEntryPage/ChangePasswordPasswordEntryPage';
import { usePasswordResetFlow } from '../hooks/usePasswordResetFlow';
import { PasswordResetStep } from '../../../../enums/AuthFlowEnums';

interface ChangePasswordWindowProps {
    passwordChangeCompletion: () => void,
    email: string
}

const ChangePasswordWindow = ({ passwordChangeCompletion, email }: ChangePasswordWindowProps) => {
    const [isVerifyingExistingPassword, setIsVerifyingExistingPassword] = useState(true);
    const flow = usePasswordResetFlow(passwordChangeCompletion, email);

    const leaveVerification = (nextStep: () => void) => {
        setIsVerifyingExistingPassword(false);
        nextStep();
    };

    const backToVerification = () => setIsVerifyingExistingPassword(true);

    return (
        <div className='forgot-password-window'>
            {isVerifyingExistingPassword
                ? <ChangePasswordPasswordEntryPage
                    email={email}
                    moveToNextPage={() => leaveVerification(flow.goToNewPasswordStep)}
                    moveToForgotPasswordPage={() => leaveVerification(flow.goToOtpStep)}
                />
                : flow.step === PasswordResetStep.Otp
                    ? <ForgotPasswordOtpInputPage flow={flow} onBack={backToVerification} />
                    : <ResetPasswordInputPage flow={flow} />}
        </div>
    )
}

export default ChangePasswordWindow